<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <h1>CONFIRMACI&Oacute;N DE CUENTA</h1>
            <p>Bienvenido, su cuenta ha sido verificada y activada correctamente. Ingrese en la aplicaci&oacute;n con ID de
                usuario y contrase&ntilde;a utlizando el bot&oacute;n de abajo e inicie la configuraci&oacute;n de su
                sistema de punto de venta XmartBusiness&reg;.</p>
            <a class="btn btn-primary" [routerLink]="['/Login']">INGRESAR</a>
        </div>
    </div>
</div>

<synergy-footer></synergy-footer>